import { Download } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField } from "@mui/material";
import { useState } from "react";
import API from "../../../services/API";

const currentYear = parseInt(new Date().getFullYear());

const currentMonth = parseInt(new Date().getMonth()) + 1;

const months = ['', 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

const width = window.innerWidth > 600 ? 500 : 280;

export default function ExportModal({open, onClose}){

    const [year, setYear] = useState(currentYear)

    const [month, setMonth] = useState(currentMonth)

    const [download, setDownload] = useState(false)

    const [error, setError] = useState(false)

    const handleClick = ext => {

        setError(false)

        setDownload(ext)

        API.download(`/orders/${year}/${month}/invoices.${ext}`)
            .catch(_ => setError(true))
            .finally(() => setDownload(false))
    }

    return <Dialog open={open} onClose={onClose}>

        <DialogTitle>Exporter des factures</DialogTitle>

        <DialogContent>

            <Stack spacing={2} sx={{minWidth: width, mt: 1}}>

                <TextField
                    select 
                    label="Année"
                    required
                    size='small'
                    value={year}
                    onChange={e => setYear(parseInt(e.target.value))}
                >
                    {[0,1,2,3,4,5,6,7,8,9,10].map(y =>
                        <MenuItem key={y} value={currentYear - y}>
                            {currentYear - y}
                        </MenuItem>    
                    )}
                </TextField>

                <TextField
                    select 
                    label="Mois"
                    required
                    size='small'
                    value={month}
                    onChange={e => setMonth(parseInt(e.target.value))}
                >
                    {[1,2,3,4,5,6,7,8,9,10,11,12].map(m =>
                        <MenuItem key={m} value={m}>
                            {months[m]}
                        </MenuItem>    
                    )}
                </TextField>

                {error && 
                    <Alert severity='error'>
                        Une erreur s'est produite.
                    </Alert>
                }

                <LoadingButton 
                    startIcon={<Download />}
                    loading={download === 'pdf'}
                    onClick={() => handleClick('pdf')}
                >
                    Exporter en PDF
                </LoadingButton>

                <LoadingButton 
                    startIcon={<Download />}
                    loading={download === 'csv'}
                    onClick={() => handleClick('csv')}
                >
                    Exporter en CSV
                </LoadingButton>

                <Alert severity='info'>
                    Attention : l'export PDF peut prendre quelques minutes.
                </Alert>

            </Stack>

        </DialogContent>

        <DialogActions>
            <Button onClick={onClose}>Annuler</Button>
        </DialogActions>

    </Dialog>

}